import SparklesIcon from "@/assets/icons/solutions/sparkles.svg?react";
import QuestionMarkIcon from "@/assets/icons/solutions/question-mark-circle.svg?react";
import ChatBubbleIcon from "@/assets/icons/solutions/chat-bubble-left-right.svg?react";
import { ROUTES } from "@/utils/navigation";

export const options = [
  {
    icon: SparklesIcon,
    title: "How to get Trackmate",
    description: "Embark on your journey towards superior asset management with our comprehensive guide to getting started with Trackmate.",
    href: ROUTES.getTrackmate
  },
  {
    icon: QuestionMarkIcon,
    title: "FAQs",
    description: "Discover clear and concise answers to the most common questions about Trackmate’s products and services.",
    href: ROUTES.faq
  },
  {
    icon: ChatBubbleIcon,
    title: "Need Help?",
    description: "Our global Customer Service team is ready to help with inquiries or general support.",
    href: ROUTES.contactUs
  }
]